var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.466,
    height: 41.466,
    viewBox: "0 0 41.466 41.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 195",
    d: "M20.733 1.386A19.548 19.548 0 1 1 1.185 20.934 19.57 19.57 0 0 1 20.733 1.386m0-1.185a20.733 20.733 0 1 0 20.733 20.733A20.733 20.733 0 0 0 20.733.2",
    transform: "translate(0 -.201)",
    style: {
      fill: "#0c91a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 196",
    d: "M33.555 5.872a20.655 20.655 0 0 1-13.793 5.253A20.663 20.663 0 0 1 5.255 5.2",
    transform: "translate(.97 .723)",
    style: {
      fill: "none",
      stroke: "#0c91a9",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 197",
    d: "M5.255 30.456a20.733 20.733 0 0 1 28.3.668",
    transform: "translate(.97 4.418)",
    style: {
      fill: "none",
      stroke: "#0c91a9",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 198",
    d: "M18.7 1.386c3.081 0 6.516 8.028 6.516 19.548S21.782 40.482 18.7 40.482s-6.516-8.028-6.516-19.548S15.619 1.386 18.7 1.386M18.7.2C14.448.2 11 9.483 11 20.934s3.448 20.733 7.7 20.733 7.7-9.282 7.7-20.733S22.954.2 18.7.2",
    transform: "translate(2.031 -.201)",
    style: {
      fill: "#0c91a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 141",
    transform: "translate(.591 20.733)",
    style: {
      fill: "none",
      stroke: "#0c91a9",
      strokeMiterlimit: 10
    },
    d: "M0 0h40.281"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 142",
    transform: "translate(20.732 1.185)",
    style: {
      fill: "none",
      stroke: "#0c91a9",
      strokeMiterlimit: 10
    },
    d: "M0 0v40.281"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.00f1b0bad29632dd4491d6bc6c07cb21.svg";
export { ForwardRef as ReactComponent };